<script lang="ts">
  /**
   * Due to privacy, we cannot load reviews unless allowed in the privacy policy
   */
  import { MenuState } from "../../Models/MenuState"
  import { UIEventSource } from "../../Logic/UIEventSource"
  import Translations from "../i18n/Translations"
  import Tr from "../Base/Tr.svelte"

  export let guistate: MenuState
  export let loadingAllowed: UIEventSource<boolean>
  export let hiddenIfNotAllowed: boolean = false
  let t = Translations.t.reviews
</script>

{#if $loadingAllowed}
  <slot />
{:else if !hiddenIfNotAllowed && $loadingAllowed !== null}
  <div class="low-interaction mx-1 flex flex-col rounded">
    <Tr t={t.disabledForPrivacy} />
    <button
      on:click={() => {
        loadingAllowed.set(true)
      }}
      class="primary"
    >
      <Tr t={t.loadOnce} />
    </button>
    <button
      class="as-link self-end"
      on:click={() => guistate.openUsersettings("mangrove-reviews-allowed")}
    >
      <Tr t={t.editPrivacySettings} />
    </button>
  </div>
{/if}
